/**
 * @generated SignedSource<<8360b5031eb52c5459725804cf2a5fd3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SpfAskStatus = "ACCEPTED" | "CANCELED" | "DEFERRED" | "DRAFT" | "IN_REVIEW" | "RESOLVED" | "REVISING" | "SUBMITTED" | "%future added value";
export type SpfAskTargetDateType = "DAY" | "MONTH" | "QUARTER" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchPassionfruitAskStatusTargetDate_AtlassianSearchPage$data = {
  readonly ask?: {
    readonly status: SpfAskStatus;
    readonly targetDate: {
      readonly targetDate: string | null | undefined;
      readonly targetDateType: SpfAskTargetDateType | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "searchPassionfruitAskStatusTargetDate_AtlassianSearchPage";
};
export type searchPassionfruitAskStatusTargetDate_AtlassianSearchPage$key = {
  readonly " $data"?: searchPassionfruitAskStatusTargetDate_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchPassionfruitAskStatusTargetDate_AtlassianSearchPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchPassionfruitAskStatusTargetDate_AtlassianSearchPage",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "SpfAsk",
          "kind": "LinkedField",
          "name": "ask",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "status"
            },
            {
              "concreteType": "SpfAskTargetDate",
              "kind": "LinkedField",
              "name": "targetDate",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "targetDate"
                },
                {
                  "kind": "ScalarField",
                  "name": "targetDateType"
                }
              ]
            }
          ]
        }
      ],
      "type": "SearchResultSpfAsk"
    }
  ],
  "type": "SearchResult",
  "abstractKey": "__isSearchResult"
};

(node as any).hash = "4f254907d88785a6e346dfbdbf1488e2";

export default node;
